import TurndownService from 'turndown'
import { gfm } from '@joplin/turndown-plugin-gfm'
import { kCitationIdRegex } from '@/util/agent-citations'
import { addPleadingCaptionTurndownRule } from '../custom_markdown_blocks/pleading-caption'
import { kArtifactLegalCitationIdAttr, kArtifactReferenceMarkerIdAttr } from './artifact-citation-helpers'

/**
 * Shared GFM serializer for the Markdown canvas.
 */
const turndownService = new TurndownService({
  headingStyle: 'atx',
  codeBlockStyle: 'fenced',
})

turndownService.use(gfm)
addPleadingCaptionTurndownRule(turndownService)

turndownService.addRule('agentV2ReferenceMarker', {
  filter: (node) => node.nodeName === 'SPAN' && node.hasAttribute(kArtifactReferenceMarkerIdAttr),
  replacement: (content, node) => {
    const citationId = (node as HTMLElement).getAttribute(kArtifactReferenceMarkerIdAttr) ?? ''
    return kCitationIdRegex.test(citationId) ? `[${citationId}]` : content
  },
})

turndownService.addRule('agentV2LegalCitation', {
  filter: (node) => node.nodeName === 'SPAN' && node.hasAttribute(kArtifactLegalCitationIdAttr),
  replacement: (content, node) => {
    const citationId = (node as HTMLElement).getAttribute(kArtifactLegalCitationIdAttr) ?? ''
    return kCitationIdRegex.test(citationId) ? `[${content}](${citationId})` : content
  },
})

export { turndownService }
